export const MuiChip = {
  styleOverrides: {
    root: {
      borderRadius: '8px',
      borderColor: 'black',
    },
  },
};
